import { Container, Typography, Box, Grid, Paper, Avatar, Divider } from '@mui/material';
import { keyframes } from '@emotion/react';
import profileImage from '../assets/images/profile.jpg';  // 添加这行在文件顶部

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

function Home() {
  return (
    <Container>
      <Box sx={{ 
        mt: 8,
        animation: `${fadeIn} 1s ease-out`
      }}>
        {/* 个人简介部分 */}
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={4}>
            <Avatar
              sx={{ 
                width: 200, 
                height: 200, 
                margin: 'auto',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',  // 添加柔和的灰色阴影
                transition: 'transform 0.3s ease',  // 添加平滑过渡效果
                '&:hover': {
                  transform: 'scale(1.05)'  // 鼠标悬停时轻微放大效果
                }
              }}
              alt="张舒昱"
              src={profileImage}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography variant="h2" component="h1" gutterBottom>
              张舒昱 / Shuyu Zhang
            </Typography>
            <Typography variant="h5" color="textSecondary" gutterBottom>
              AI产品经理 / AI Product Manager
            </Typography>
            <Typography variant="body1" paragraph>
              Washington University in St. Louis -> Alibaba Group - Cainiao AI
            </Typography>
            <Typography variant="body1" color="textSecondary" 
              onClick={() => {
                const email = document.querySelector('#contact-email');
                email.style.transition = 'color 0.3s';
                email.style.color = '#1976d2';
                setTimeout(() => {
                  email.style.color = 'rgba(0, 0, 0, 0.6)';
                }, 1000);
              }}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  color: 'primary.main',
                }
              }}
            >
              E-mail: <span id="contact-email">zhangshuyu991009@gmail.com</span>
            </Typography>
          </Grid>
        </Grid>
      </Box>
      
      <Box sx={{ mt: 8 }}>
        {/* Work Experience */}
        <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
          Work Experience
        </Typography>
        <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            ALIBABA GROUP @ HANGZHOU, CHINA
          </Typography>
          <Typography variant="subtitle1" color="textSecondary" gutterBottom>
            2021.06 - Now
          </Typography>
          
          <Typography variant="h6" sx={{ mt: 3 }}>
            Head of AI Product, Cainiao Group
          </Typography>
          <Typography variant="body1" paragraph>
            Head of AI Product Department. CTO Supreme Award (the only product manager and youngest among the winners). The highest rating for 3 consecutive years. Established the foundational framework of Cainiao AI's LLM related products, bringing international recognition and hundreds of millions worth of business value.
          </Typography>
          
          <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 'bold' }}>
            Model Customization (30%)
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
            <li>Product Strategy: Led the direction and positioning of Cainiao's self-developed LLM based on industry tracking, research, and internal resource capability assessment. Created China's first domain-specific big model for the logistics industry with less than 1% of the rival's budget, winning the SAIL AWARD Top30 at WAIC 2023</li>
            <li>Model Performance & User Experience Improvement: Coordinated with world-leading academic and industry partners to find solutions to address user pain points and key needs, designed improvements that achieved the highest scores on logistics domain test sets, and settled down 5+ model customization contracts with industry clients</li>
            <li>Model Filing and AI Compliance: Led and managed all government filings and AI compliance for models to be officially put into use in reality, and secured a 5 million RMB subsidy from Hangzhou Municipal Government for scientific achievement</li>
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 'bold' }}>
            LLM Application Platform (40%)
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
            <li>Core Feature Planning & Designing: Targeted all employees including non-tech ones as users, providing efficiency-improving tools such as a fine-tuning platform, 0-code LLM application development platform, and Agent-Flow platform, bringing 10,000+ different GPTs developed solely by employees (User Penetration Rate: 83.2%) and 10M hours of efficiency value to the company recognized by the board & senior management</li>
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 'bold' }}>
            AI Application Solutions – Customer Success (30%)
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
            <li>Industry Application: Provided scenario-based solutions for big clients in various fields who wish to use AI to enhance their domain products. With a deep understanding of various product and business models, customized product positioning, value, solutions, and key selling points for clients, customer satisfaction rate 100%, bringing millions of times daily model invocation among clients</li>
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6">
            Commercial Product Manager, Home-Furnishing Industry Department
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
            <li>Sole owner of a new industry initiative, deploying product strategies and tactics that grew the business from 0 to ¥1 billion in annual revenue within one year, becoming an industry game-changer.</li>
            <li>Industry Research & Strategy: Conducted in-depth research on traditional players and industry structure, identified key resources in installers and business orders, and promoted cooperation with major e-commerce platforms and installer fleets. Became the most resourceful supplier during the D11 shopping festival, securing top-5 clients swiftly and dominating 10% of the market share within one year</li>
            <li>Product Design: Designed products for customers, installers, drivers, client-service, and clients, covering the tool-based, data-driven, and user-centered product span required for business growth</li>
          </Typography>
        </Paper>

        {/* Internship Experience */}
        <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
          Internship Experience
        </Typography>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6">
              Fortune VC, Consumer & SaaS Group | Investment Associate
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              2020.05 - 2021.06
            </Typography>
            <Typography variant="body1">
              Assisted the managing partner completing two ¥50 million investments in two unicorns (Beauty and SaaS industry respectively)
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6">
              L'Oreal, LANCOME Digital Marketing Department | Summer Intern
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              2019.01 - 2019.08
            </Typography>
            <Typography variant="body1">
              In charge of the social media section in 3 major campaigns, one of which won several awards in creativity and social influence (the TIU new launch)
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h6">
              Huatai United Securities, Investment Banking | Summer Intern
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              2018.06 - 2018.09
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6">
              PwC, Assurance Department | Winter Intern
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              2018.01 - 2018.02
            </Typography>
          </Box>
        </Paper>
        {/* Personal Achievements */}
        <Typography variant="h4" gutterBottom sx={{ mt: 8, mb: 4 }}>
          Personal Achievements
        </Typography>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
            <li>Registered Yoga Teacher @ RYS 200 Yoga Alliance, Yoga Spreader and 15 years Yogini</li>
            <li>1st Dan Black Belt @ ITF Taekwondo, National Silver Award Winner</li>
            <li>National Level II Tennis Umpire @ Chinese Tennis Association</li>
            <li>Vocalist @ Band 2048, Songwriter</li>
            <li>Honorary Volunteer @ 4th People's Hospital for 20 years (since the age of 5)</li>
            <li>All-Pass Member @ Association of Chartered Certified Accountants (ACCA)</li>
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
}

export default Home;